import { ApiResponse } from 'apisauce';

import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import {
  DailyAvailabilityQueryModel,
  DailyAvailabilityResponseModel
} from '../shared/models/daily-availability.model';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';

const MODULE_NAME = 'DAILY_AVAILABILITY_MODULE';

export function getDailyAvailabilityReport(
  query: DailyAvailabilityQueryModel
): Promise<DailyAvailabilityResponseModel | ErrorInfo> {
  return api
    .getDailyAvailabilityReport(query)
    .then((response: ApiResponse<ResponseModel<DailyAvailabilityResponseModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        }

        return errorHelper(
          0,
          '',
          MODULE_NAME,
          (api.getDailyAvailabilityReport as any).displayName
        );
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode ? String(response.data.errorCode || '') : response.problem,
        MODULE_NAME,
        (api.getDailyAvailabilityReport as any).displayName
      );
    });
}
